module.exports = __webpack_public_path__ + "img/permaDao_logo.4104f56e.svg";